import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleNotify({ moduleKey, item, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mod/${moduleKey}/items/${item.id}/send`);
      toast.success(`Notificación enviada a ${data.sent} personas`);
      onRefresh?.();
    } catch (err) { toast.error(err?.response?.data?.detail || "No se pudo enviar"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-2" data-testid="module-notify">
      <div className="overline text-navy/40">Enviar notificación</div>
      <p className="text-sm text-navy/50">Envía esta notificación a todos los colaboradores de tu empresa.</p>
      <button onClick={send} disabled={busy} className="btn btn-primary" data-testid="notify-send-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {item.estado === "enviada" ? "Reenviar" : "Enviar ahora"}
      </button>
    </div>
  );
}
